import UltMeta, { Meta } from "@/meta/UltMeta/index";

/**
 * 广告分类
 */
class Classify extends UltMeta {
    PC = new Meta(1, "PC端");
    WX = new Meta(2, "移动端");
}

export const CLASSIFY = new Classify();

/**
 * 广告类型
 */
class AdvertType extends UltMeta {
    IMAGE = new Meta(1, "图片");
    TEXT = new Meta(2, "文本");
}

export const ADVERT_TYPE = new AdvertType();

/** 按钮类型 */

class ButtonType extends UltMeta {
    PRODUCT = new Meta(1, "商品");
    PRODUCT_TYPE = new Meta(2, "砂价");
    WHARF = new Meta(3, "运价");
    CONTACT = new Meta(4, "联系方式");
    INFORMATION = new Meta(5, "资讯");
}
export const BUTTON_TYPE = new ButtonType();
